<template>
  <MainViewFrame>
    <div class="courseView">
      <div class="items">
        <div class="item" v-for="(item, index) in data" :key="item.pk?item.pk:item.id">
          <VideoCourseItem :dic="item" tag="video"/>
        </div>
      </div>
    </div>
  </MainViewFrame>
</template>

<script>
// @ is an alias to /src
import MainViewFrame from '../MainViewFrame.vue'
import VideoCourseItem from './components/VideoCourseItem.vue';

import { types as VideoCourseTypes } from '@/store/modules/video_course.js'
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "VideoCourse",
  components: {
    MainViewFrame,
    VideoCourseItem
  },
  data () {
    return {
    };
  },
  computed: {
    ...mapState({
      data: state => state.video_course.videos.data,
      page: state => state.video_course.videos.page,
      load_more: state => state.video_course.videos.load_more,
      total_count: state => state.video_course.videos.total_count,
    })
  },

  methods: {
    ...mapActions({
      fetchCategoryVideoCourseData: VideoCourseTypes.FETCH_LIST_DATA_VIDEOS,
    }),

    handleScroll(e) {
      let page = this.page;
      let load_more = this.load_more;
      
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }
      
      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchCategoryVideoCourseData({page:page+1, category_id:that.category_id})
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    },

  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted () {
    if (this.$route.params.category_id) {
      this.category_id = this.$route.params.category_id;
    } 
    this.fetchCategoryVideoCourseData({page:1, category_id:this.category_id})
  }
};
</script>

<style lang="less" scoped>
.courseView{
  background-color: #F8F8F8;
  border-radius: 4px;
  padding: 10px;
  
  .items{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px 0;
    margin-left: -10px;
    margin-bottom: 0;
    min-height: 120px;
    .item{
      width: calc(100% / 3 - 12px);
      margin-left: 10px;
      margin-bottom: 10px;
      border: solid 1px #EBEBEB;
      cursor: pointer;
      background-color: #ffffff;
      border-radius: 4px;
      overflow: hidden;
    }
  }
  
}
</style>
